import '@hotmart-org-ca/cosmos/dist/styles/reset.css';
import '@hotmart-org-ca/cosmos/dist/styles/base.css';
import '@hotmart-org-ca/cosmos/dist/styles/theme.css';
import '@hotmart-org-ca/cosmos/dist/grid/grid.css';
import '@hotmart-org-ca/cosmos/dist/form/form.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/cursor.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/grays.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/blue.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/green.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/red.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/yellow.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/primary.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/display/display.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/flex/flex.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/sizing/sizing.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/spacing/spacing.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/border/border.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/border/variations/grays.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/text.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/grays.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/blue.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/green.css';
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/red.css';
import React, { useEffect, createContext, useContext, forwardRef, useRef } from 'react';
import { CacheProvider, css } from '@emotion/react';
import createCache from '@emotion/cache';
import classNames from 'classnames';
import '@hotmart-org-ca/cosmos/dist/avatar';
import '@hotmart-org-ca/cosmos/dist/collapse';
import '@hotmart-org-ca/cosmos/dist/button/button.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/primary.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/secondary.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/tertiary.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/info.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/success.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/danger.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/warning.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/block.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/small.css';
import '@hotmart-org-ca/cosmos/dist/button/variations/large.css';
import '@hotmart-org-ca/cosmos/dist/card/card.css';
import '@hotmart-org-ca/cosmos/dist/card/card-header.css';
import '@hotmart-org-ca/cosmos/dist/card/card-body.css';
import '@hotmart-org-ca/cosmos/dist/card/card-footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@hotmart-org-ca/cosmos/dist/form/input-default.css';
import '@hotmart-org-ca/cosmos/dist/form/input-validate.css';
import '@hotmart-org-ca/cosmos/dist/form/variations/large.css';
import '@hotmart-org-ca/cosmos/dist/loading';
import '@hotmart-org-ca/cosmos/dist/modal';
import '@hotmart-org-ca/cosmos/dist/modal/modal-header';
import '@hotmart-org-ca/cosmos/dist/modal/modal-body';
import '@hotmart-org-ca/cosmos/dist/modal/modal-footer';
import '@hotmart-org-ca/cosmos/dist/nav/nav.css';
import '@hotmart-org-ca/cosmos/dist/popover';
import '@hotmart-org-ca/cosmos/dist/form/input-custom.css';
import '@hotmart-org-ca/cosmos/dist/form/input-switch.css';
import '@hotmart-org-ca/cosmos/dist/form/input-radio.css';
import '@hotmart-org-ca/cosmos/dist/form/input-checkbox.css';
import ReactSelect from 'react-select';
import { jsx } from '@emotion/react/jsx-runtime';
import '@hotmart-org-ca/cosmos/dist/alert';
import '@hotmart-org-ca/cosmos/dist/toast';
import '@hotmart-org-ca/cosmos/dist/alert/variations/danger.css';
import '@hotmart-org-ca/cosmos/dist/alert/variations/info.css';
import '@hotmart-org-ca/cosmos/dist/alert/variations/success.css';
import '@hotmart-org-ca/cosmos/dist/alert/variations/warning.css';
import ToastUtils from '@hotmart-org-ca/cosmos/dist/toast/utils';
import '@hotmart-org-ca/cosmos/dist/tooltip';

function EmotionStyleSheetProvider(props) {
  const [cache, setCache] = React.useState(null);
  React.useEffect(() => {
    if (props?.stylesRoot) {
      setCache(createCache({
        container: props.stylesRoot,
        key: 'css',
        prepend: false
      }));
    }
  }, [props.stylesRoot]);
  if (cache === null) {
    return React.createElement(React.Fragment, null, props.children);
  }
  return React.createElement(React.Fragment, null, React.createElement(CacheProvider, {
    value: cache
  }, props.children));
}

const Section = ({
  children,
  title,
  className,
  bgBoxColor = 'gray-100',
  box
}) => {
  const constuctClassName = box ? `_bg-${bgBoxColor} _rounded-lg _p-5 _p-md-7` : '';
  return React.createElement("section", {
    className: `${constuctClassName} ${className ?? ''}`.trim()
  }, title && React.createElement("h2", {
    className: "_m-0 _text-5 _font-weight-light"
  }, title), children);
};

const Container = ({
  children
}) =>
// @ts-ignore
React.createElement("div", {
  css: css`
    margin: 0 auto;
    max-width: 1101px;
    width: 100%;
    @media (max-width: 767px) {
      max-width: 100%;
      width: 100%;
    }
  `
}, children);

var index = {
  __proto__: null,
  Container: Container,
  Section: Section
};

const noAvatarImage = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAQ4BDgMBIgACEQEDEQH/xAAaAAEBAAMBAQAAAAAAAAAAAAAAAQMEBQIH/9oACAEBAAAAAPpQACgIAAAFAAgAAFCgQIAAKKACCAAUpdvZ9vGprIIQAKVfXSygw82IQgBSq6WcBq6MIiAFVWXqAE5MREQCqq9DYAHP1yRCAqrXRzgDV0oiIgVVW9LKAMPPkRIgVVq9PIAMPPiREQVatdX0ANTUSJEQVatu9sADn4pIkRCqq25ugAeebJEiRCqtWun7AaurJEiRCqq2s+9QTmySJEiCrVtXc2Qa2pEkSIgq1atvUBoYpEiREFVatbG8DxzUiREQVVVc2/6A09WIiRAVVvvc2QBh0sSIiAqsm5s0AExaWGIgC3e26AAGHneIgD11coAADzzMMAXp7AAAAx8iANvogAAA0NIB1swAAAMPJAdb36oAACNbmgC+8mT3lmfx69eMnjx58zDMWOAAAFBAAAAAAAAAAAAAAAAAAAP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oACAECEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//xAAyEAACAQIEAwUGBwEAAAAAAAABAgMABBESMUAhMEETIlFhgRQgMlNxoQUjQ1JwkbFC/9oACAEBAAE/AP4VAJOAFJasQC5w8qFtCn/JJ867KIfpr/VdjEQSUHoKa0iKk8VqS2deK94btVLsANajhWMefU+/Nbh1zjAH/aIIOB3NvGETEjvNybqLSQD67iFM8gHTU8oqGUqeoojKSD0O3sAql3P0HLuABK3nt7XARY4Yknl3uHaKRplwG3t+ESevLvQoCZehPHbwH8mP1/3l3z58gGgO3tBmhw6ZuXdHvKPAbezJOZPXlzNmkYjbwNlkU9NOVI2VGO5hkzxjxHA8m5biE9TuYJDE4PTkEhQSaYliSeu6t5AcEb09+4fRfU7saj35gRI27t0zOG6D37xM+DgcQNPLdRxNJ5DxpVCDAciaHL3k026I7/CKjtlXi/E8uS3VxmHdNPG8eo9dmkbyfCKjtlXi3E0ABpzpbaNvh4Hy0p4XTUYjxHPALEADE1FagcX4nwoADgNlJbxuMR3Wp43jODDmKpdgo1NRRLEPPqdqyK65SOFTRNC+U6dOXBF2a4n4jrt5YxKhB9KIIJB1HJtYw75m0Xc30XZyg/uHJt1yQqP3cTub1VMOKjQ8lL2HIiHMAB4UJoW/UFAg6EHbdpGurrU08JiZQ2LHmCWRdHYetLdTqcQ9C+nAw4EUL9wMDGuFH8QVji0X3r22PLhlYeNLf24GADf1S3cAHBjieuGlJc23V/sa9qg+ZXb2/wA37Gva7f5n2NG7gwygnD6ULyFQcMxbxwr2yIDgjE0b5QuVYz58aP4i+GCoBRvJOgUUbu4PDPhRmmOsjf3RJOpJ/g//xAAUEQEAAAAAAAAAAAAAAAAAAACA/9oACAECAQE/ABD/AP/EABQRAQAAAAAAAAAAAAAAAAAAAID/2gAIAQMBAT8AEP8A/9k=';

const Avatar = /*#__PURE__*/React.forwardRef(({
  className,
  size = 'xxl',
  avatarText,
  rounded,
  src = noAvatarImage,
  ...rest
}, ref) => {
  const cx = classNames({
    'hot-avatar--xs': size === 'xs',
    'hot-avatar--sm': size === 'sm',
    'hot-avatar--md': size === 'md',
    'hot-avatar--lg': size === 'lg',
    'hot-avatar--xl': size === 'xl',
    'hot-avatar--xxl': size === 'xxl',
    'hot-avatar--circle': !rounded,
    'hot-avatar--rounded': rounded,
    'hot-avatar--text': avatarText
  }, className);
  return React.createElement("hot-avatar", {
    class: cx,
    ...(!avatarText && {
      src: src
    }),
    ...rest,
    ref: ref
  }, avatarText && React.createElement("span", null, avatarText));
});

const Collapse = ({
  bodyClassName = '',
  children,
  className,
  header,
  headerClassName = '',
  isActive,
  onClose = () => {},
  onOpen = () => {}
}) => {
  const collapseRef = React.useRef(null);
  useEffect(() => {
    collapseRef.current?.addEventListener('open', onOpen);
    collapseRef.current?.addEventListener('close', onClose);
    return () => {
      collapseRef.current?.removeEventListener('open', onOpen);
      collapseRef.current?.removeEventListener('close', onClose);
    };
  }, []);
  return React.createElement("hot-collapse", {
    ref: collapseRef,
    ...(isActive && {
      active: true
    }),
    class: className
  }, header && React.createElement("div", {
    className: headerClassName
  }, header), React.createElement("div", {
    slot: "collapsed",
    className: bodyClassName
  }, children));
};

function Button({
  children,
  className,
  color,
  loading,
  fullWidth,
  size,
  type = 'button',
  ...rest
}) {
  const cx = classNames('hot-button', {
    'hot-button--primary': color === 'primary',
    'hot-button--secondary': color === 'secondary',
    'hot-button--tertiary': color === 'tertiary',
    'hot-button--info': color === 'info',
    'hot-button--success': color === 'success',
    'hot-button--danger': color === 'danger',
    'hot-button--warning': color === 'warning',
    'hot-button--loading': !!loading,
    'hot-button--block': !!fullWidth,
    'hot-button--sm': size === 'small',
    'hot-button--md': size === 'medium',
    'hot-button--lg': size === 'large'
  }, className);
  return React.createElement("button", {
    type: type,
    className: cx,
    ...rest
  }, children);
}

const CardHeader = /*#__PURE__*/React.forwardRef(({
  children,
  className,
  ...rest
}, ref) => {
  return React.createElement("hot-card-header", {
    class: className,
    ...rest,
    ref: ref
  }, children);
});
CardHeader.displayName = 'CardHeader';

const CardBody = /*#__PURE__*/React.forwardRef(({
  children,
  className,
  ...rest
}, ref) => {
  return React.createElement("hot-card-body", {
    class: className,
    ...rest,
    ref: ref
  }, children);
});
CardBody.displayName = 'CardBody';

const CardFooter = /*#__PURE__*/React.forwardRef(({
  children,
  className,
  ...rest
}, ref) => {
  return React.createElement("hot-card-footer", {
    class: className,
    ...rest,
    ref: ref
  }, children);
});
CardFooter.displayName = 'CardFooter';

const Card = /*#__PURE__*/React.forwardRef(({
  children,
  className,
  shadow,
  bordered,
  hover,
  active,
  ...rest
}, ref) => {
  const cx = classNames({
    'hot-card--shadow-sm': shadow === 'sm',
    'hot-card--shadow': shadow === 'md',
    'hot-card--shadow-lg': shadow === 'lg',
    'hot-card--bordered': bordered,
    'hot-card--hover': hover,
    'hot-card--active': active
  }, className);
  return React.createElement("hot-card", {
    class: cx,
    ref: ref,
    ...rest
  }, children);
});
const CompoundedCard = /*#__PURE__*/Object.assign({}, Card, {
  Header: CardHeader,
  Body: CardBody,
  Footer: CardFooter,
  displayName: Card
});

const Icon = ({
  iconName,
  label = iconName,
  type = 'regular',
  ...rest
}) => {
  const PREFIXES = {
    regular: 'far',
    solid: 'fa',
    light: 'fal'
  };
  const prefix = PREFIXES[type];
  return React.createElement(FontAwesomeIcon, {
    icon: [prefix, iconName],
    ...rest
  });
};

const InputContext = /*#__PURE__*/createContext({
  name: 'input'
});
const useInputContext = () => useContext(InputContext);
const InputProvider = ({
  children,
  props
}) => React.createElement(InputContext.Provider, {
  value: props
}, children);

const HelperStatus = () => {
  const {
    errorMessage,
    helperText,
    variationModifier,
    variationModifierMessage,
    variationModifierFeedback
  } = useInputContext();
  if (errorMessage) {
    return React.createElement("div", {
      className: "invalid-feedback"
    }, errorMessage);
  }
  if (variationModifier && variationModifierFeedback && variationModifierMessage) {
    return React.createElement("div", {
      className: variationModifierFeedback
    }, variationModifierMessage);
  }
  if (helperText) {
    return helperText;
  }
  return null;
};

const FormLabel = () => {
  const {
    label,
    name,
    labelClassName,
    tooltip
  } = useInputContext();
  if (!label) {
    return null;
  }
  return React.createElement("label", {
    htmlFor: name,
    className: classNames('hot-form__label', labelClassName)
  }, label, tooltip);
};

const InputGroup = ({
  children
}) => {
  const {
    className
  } = useInputContext();
  return React.createElement("div", {
    className: "input-group"
  }, React.createElement(FormLabel, null), React.createElement("div", {
    className: classNames('hot-input-group--wrapper', className)
  }, children, React.createElement(HelperStatus, null)));
};

const Input = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    errorMessage,
    helperText,
    inputClassName = '',
    label,
    labelClassName = '',
    name,
    sibling,
    tooltip,
    variationModifier = '',
    variationModifierFeedback = '',
    variationModifierMessage = '',
    variationSize = '',
    ...rest
  } = props;
  const cx = classNames('hot-form__input', {
    'hot-form__input--sm': variationSize === 'sm',
    'hot-form__input--lg': variationSize === 'lg',
    'is-valid': variationModifier === 'is-valid',
    'is-invalid': [Boolean(errorMessage), Boolean(variationModifier)].includes(true)
  }, inputClassName);
  return React.createElement(InputProvider, {
    props: {
      className,
      errorMessage,
      helperText,
      inputClassName,
      label,
      labelClassName,
      name,
      tooltip,
      variationModifier,
      variationModifierFeedback,
      variationModifierMessage,
      variationSize
    }
  }, React.createElement(InputGroup, null, React.createElement("input", {
    id: name,
    name: name,
    className: cx,
    ref: ref,
    ...rest
  }), props.sibling));
});
Input.displayName = 'Input';

const Loading = () => React.createElement("div", {
  className: "_text-center"
}, React.createElement("hot-loading", null));

function ModalHeader({
  children
}) {
  return React.createElement("hot-modal-header", null, children);
}

function ModalBody({
  children
}) {
  return React.createElement("hot-modal-body", null, children);
}

function ModalFooter({
  children
}) {
  return React.createElement("hot-modal-footer", null, children);
}

const Modal = props => {
  const {
    open,
    children,
    onClose,
    uncentered = false
  } = props;
  const modalRef = useRef(null);
  useEffect(() => {
    const current = modalRef.current;
    current?.addEventListener('close', onClose);
    return () => {
      current?.removeEventListener('close', onClose);
    };
  }, [onClose]);
  return React.createElement("hot-modal", {
    ref: modalRef,
    ...(open && {
      open: true
    }),
    position: uncentered ? '' : 'centered'
  }, children);
};
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

const Nav = ({
  children,
  type = 'tabs',
  className = ''
}) => {
  const typeClass = `hot-nav--${type}`;
  const classes = `${className} ${typeClass}`;
  return React.createElement("hot-nav", {
    class: classes
  }, children);
};
Nav.displayName = 'Nav';

const NavItem = ({
  children,
  active = false,
  className = '',
  onClick = () => null
}) => {
  const classes = `${className} ${active ? 'hot-nav__item--active' : 'hot-nav__item'}`;
  return React.createElement("hot-nav-item", {
    class: classes,
    onClick: onClick
  }, children);
};

const CircleQuestion = () => React.createElement("i", {
  "aria-label": "action"
}, React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  "aria-hidden": "true",
  focusable: "false",
  className: "_w-4 _h-4",
  role: "img"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM240 344c-13.25 0-24 10.75-24 24s10.75 24 24 24s24-10.75 24-24S253.3 344 240 344zM285.6 128H226.4C189.8 128 160 157.8 160 194.4V204c0 8.844 7.156 16 16 16S192 212.8 192 204V194.4C192 175.4 207.4 160 226.4 160h59.25C304.6 160 320 175.4 320 194.4c0 12.48-6.781 24-17.06 29.72L242.5 254.3C231.1 260.7 224 272.7 224 285.8V304C224 312.8 231.2 320 240 320S256 312.8 256 304V285.8c0-1.453 .7813-2.797 1.438-3.172l60.41-30.22C338.9 240.7 352 218.5 352 194.4C352 157.8 322.2 128 285.6 128z"
})));

const Popover = ({
  bodyClassName = '',
  children,
  className = '',
  dismissible,
  header,
  headerClassName = '',
  icon,
  position = 'top'
}) => {
  return React.createElement("hot-popover", {
    position: position,
    ...(dismissible && {
      dismissible: true
    }),
    class: className
  }, React.createElement("span", {
    slot: "button",
    style: {
      cursor: 'pointer'
    }
  }, icon ?? React.createElement(CircleQuestion, null)), header && React.createElement("div", {
    slot: "header",
    className: classNames('hot-popover__header', headerClassName)
  }, header), React.createElement("div", {
    slot: "body",
    className: classNames('hot-popover__body', bodyClassName)
  }, children));
};

const RadioOrCheckbox = /*#__PURE__*/React.forwardRef(({
  name,
  id = name,
  label = name,
  type,
  className = '',
  labelClassName = '',
  inputClassName = '',
  variationModifier = '',
  ...rest
}, ref) => {
  const cxForm = classNames('hot-form--custom', {
    'hot-form--radio': type === 'radio',
    'hot-form--switch': type === 'switch',
    'hot-form--checkbox': type === 'checkbox'
  }, className);
  const cx = classNames('hot-form__input', {
    'is-valid': variationModifier === 'is-valid',
    'is-invalid': variationModifier === 'is-invalid'
  }, inputClassName);
  return React.createElement("div", {
    className: cxForm
  }, React.createElement("input", {
    id: id,
    name: name,
    type: type === 'switch' ? 'checkbox' : type,
    className: cx,
    ref: ref,
    ...rest
  }), React.createElement("label", {
    className: classNames('hot-form__label', labelClassName),
    htmlFor: id
  }, label));
});

const customStyles = {
  input: provided => ({
    ...provided,
    paddingLeft: 4
  }),
  menu: provided => ({
    ...provided,
    marginTop: 0
  }),
  singleValue: provided => ({
    ...provided,
    paddingLeft: 4
  }),
  container: provided => ({
    ...provided,
    padding: '0 !important',
    minHeight: 42
  }),
  control: provided => ({
    ...provided,
    paddingTop: 1,
    paddingBottom: 1,
    borderStyle: 'none',
    borderWidth: 0,
    boxShadow: 'none',
    height: '100%',
    '&:hover': {
      borderColor: 'hsl(0%, 0%, 70%)'
    }
  }),
  indicatorSeparator: provided => ({
    ...provided,
    width: 0
  }),
  placeholder: base => ({
    ...base,
    color: '#9EA4AC',
    padding: 4
  }),
  option: (styles, {
    isDisabled,
    isFocused,
    isSelected,
    errorMessage
  }) => ({
    ...styles,
    fontWeight: 'normal',
    backgroundColor: isDisabled ? undefined : isSelected || isFocused ? '#E6E9ED' : undefined,
    color: isDisabled ? undefined : isSelected ? '#191C1F' : undefined,
    borderColor: errorMessage ? 'var(--red)' : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: isSelected ? '#E6E9ED' : undefined
    }
  })
};
const Select = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    errorMessage,
    helperText,
    inputClassName = '',
    label,
    labelClassName = '',
    name,
    sibling,
    tooltip,
    variationModifier = '',
    variationModifierFeedback = '',
    variationModifierMessage = '',
    variationSize = '',
    ...rest
  } = props;
  const cx = classNames('hot-form__input', {
    'is-invalid': [Boolean(errorMessage), Boolean(variationModifier)].includes(true)
  });
  return React.createElement(InputProvider, {
    props: {
      className,
      errorMessage,
      helperText,
      inputClassName,
      label,
      labelClassName,
      name,
      sibling,
      tooltip,
      variationModifier,
      variationModifierFeedback,
      variationModifierMessage,
      variationSize
    }
  }, React.createElement(InputGroup, null, React.createElement(ReactSelect, {
    className: cx,
    ...rest,
    styles: customStyles,
    ref: ref
  }), props.sibling));
});

const BaseStepperItemCss = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;

  &::before {
    content: '';
    position: relative;
    width: 1rem;
    height: 1rem;
    border: transparent;
    background-color: transparent;
    border-radius: 50%;
    margin: 0 auto;
  }

  &:not(:last-child):after {
    content: '';
    position: relative;
    width: calc(100% - 1.5rem);
    height: 1px;
    background-color: var(--gray-300);
    top: 0.5rem;
    left: calc(50% + 0.75rem);
    order: -1;
  }
`;
const StepperWrapper = ({
  children,
  className,
  ...props
}) => jsx("ol", {
  className: className,
  // @ts-ignore
  css: css`
      display: flex;
      flex: 1;
      listStyle: 'none';
      padding: 0;
      margin: 0;
    `,
  ...props,
  children: children
});
const StepperItem = ({
  children,
  ...props
}) =>
// @ts-ignore
jsx("li", {
  css: BaseStepperItemCss,
  ...props,
  children: children
});
const StepperItemActive = ({
  children,
  ...props
}) => jsx("li", {
  // @ts-ignore
  css: css`
      ${BaseStepperItemCss}

      &::before {
        border: 1px solid var(--gray-900) !important;
        background-color: var(--white) !important;
      }

      .step-label {
        margin-top: calc(var(--spacer-3) + 0.25rem);
        font-weight: var(--font-weight-bold);

        &::before {
          width: 0.25rem !important;
          height: 0.25rem !important;
          border: none !important;
          background-color: var(--gray-900) !important;
          top: calc(calc(var(--spacer-3) * -1) - 0.75rem - 2px) !important;
        }
      }
    `,
  ...props,
  children: children
});
const StepperItemCompleted = ({
  children,
  ...props
}) => jsx("li", {
  // @ts-ignore
  css: css`
      ${BaseStepperItemCss}

      &::after {
        background-color: var(--gray-400) !important;
      }

      .step-label {
        font-weight: var(--font-weight);
        color: var(--gray-500);
        &::before {
          border: none !important;
          background-color: var(--gray-900) !important;
        }
      }
    `,
  ...props,
  children: children
});
const StepperLabel = ({
  children,
  className,
  ...props
}) => {
  return jsx("span", {
    // @ts-ignore
    css: css`
        margin-top: var(--spacer-3);

        &::before {
          content: '';
          position: relative;
          display: block;
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 50%;
          border: 1px solid var(--gray-300);
          background-color: var(--white);
          top: calc(calc(var(--spacer-3) * -1) - 0.75rem);
          margin: 0 auto;
        }
      `,
    className: className,
    ...props,
    children: children
  });
};

const Stepper = ({
  steps,
  className,
  itemClassName,
  itemActiveClassName,
  itemCompletedClassName
}) => {
  const activeIndex = steps.findIndex(item => item.active);
  const cxItem = classNames('step-label', '_text-gray-400', itemClassName);
  const cxItemAtive = classNames('step-label', '_text-gray-900', itemActiveClassName);
  const cxItemCompleted = classNames('step-label', itemCompletedClassName);
  return React.createElement(StepperWrapper, {
    className: classNames('_text-1', '_text-sm-2', className)
  }, steps.map((step, index) => {
    if (index < activeIndex) {
      return React.createElement(StepperItemCompleted, {
        key: step.key,
        "data-status": "completed"
      }, React.createElement(StepperLabel, {
        className: cxItemCompleted
      }, step.label));
    }
    if (step.active) {
      return React.createElement(StepperItemActive, {
        key: step.key,
        "data-status": "active"
      }, React.createElement(StepperLabel, {
        className: cxItemAtive
      }, step.label));
    }
    return React.createElement(StepperItem, {
      key: step.key
    }, React.createElement(StepperLabel, {
      className: cxItem
    }, step.label));
  }));
};

const TextArea = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    errorMessage,
    helperText,
    inputClassName = '',
    label,
    labelClassName = '',
    name,
    sibling,
    tooltip,
    variationModifier = '',
    variationModifierFeedback = '',
    variationModifierMessage = '',
    variationSize = '',
    ...rest
  } = props;
  const cx = classNames('hot-form__input', {
    'hot-form__input--sm': variationSize === 'sm',
    'hot-form__input--lg': variationSize === 'lg',
    'is-valid': variationModifier === 'is-valid',
    'is-invalid': variationModifier === 'is-invalid'
  }, inputClassName);
  return React.createElement(InputProvider, {
    props: {
      className,
      errorMessage,
      helperText,
      inputClassName,
      label,
      labelClassName,
      name,
      tooltip,
      variationModifier,
      variationModifierFeedback,
      variationModifierMessage,
      variationSize
    }
  }, React.createElement(InputGroup, null, React.createElement("textarea", {
    id: name,
    name: name,
    className: cx,
    ref: ref,
    ...rest
  }), props.sibling));
});
TextArea.displayName = 'TextArea';

const Toast = () => React.createElement("hot-toast", null);

const TOAST_POSITION = 'top right';
function useToast() {
  const show = (type, message) => {
    ToastUtils[type]({
      message,
      position: TOAST_POSITION,
      dismissible: false
    });
  };
  return {
    show
  };
}

const Tooltip = ({
  children,
  content,
  position = 'top',
  className = ''
}) => {
  return React.createElement("hot-tooltip", {
    content: content,
    position: position,
    class: className
  }, React.createElement("span", {
    className: "_ml-2"
  }, children ?? React.createElement(CircleQuestion, null)));
};

export { Avatar, Button, CompoundedCard as Card, Collapse, EmotionStyleSheetProvider, Icon, Input, index as Layout, Loading, Modal, Nav, NavItem, Popover, RadioOrCheckbox, Select, Stepper, TextArea, Toast, Tooltip, useToast };
//# sourceMappingURL=user-account-ui.esm.js.map
